export default __webpack_public_path__ + "static/media/SerialNumber_position.15ab0143.png";